export const START_LOADING = 'LOADING/START_LOADING';
export const FINISH_LOADING = 'LOADING/FINISH_LOADING';

export function startLoading() {
  return {
    type: START_LOADING,
  };
}

export function finishLoading() {
  return {
    type: FINISH_LOADING,
  };
}
